export default __webpack_public_path__ + "static/media/operation-of-buildings.fbde5542.jpg";